import './informacoes.css';
import { useNavigate } from 'react-router-dom'
import { useState } from 'react';
import BannerHomePhone from '../../Banners/BannerHomePhone/BannerHomePhone.js'
import Button from '../../../components/Button/button';

function Informacoes() {
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(true)
    

    return (
        <div className="home">
            <div className='backgroundLateral'></div>
            <div>
                <div className='informacoesAguarde2'>
                    <div className='informacoes_recebidas'>Informações recebidas com sucesso!</div>
                    <h3 className='informacoesH3'>O próximo passo para sua segurança é o aceite da proposta, através de uma selfie que servirá como a sua assinatura digital.</h3>
                    <p className='pInformacoes'>Você pode visualizar os próximos passos através do vídeo abaixo ou seguir nossas dicas!</p>
                    <div className='cb'></div>
                    
                    <div className='videoYoutube'>
                        <iframe class="sizeVideo" src="https://www.youtube.com/embed/edrXEHwe3jY?controls=0&amp;start=3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>

                    <div className='btnRodape'>
                        <button
                            className='btnContinuar2'
                            cursor='pointer'
                            onClick={() => navigate("/fique-atento")}>
                            VER DICAS ESCRITAS
                        </button>
                    </div>
                </div>
            </div>
            <div className='backgroundLateral'></div>
        </div>
    );
}

export default Informacoes;